import { useCallback, useEffect } from 'react'
import * as FullStoryBrowser from '@fullstory/browser'

import { config } from '@/config'
import { useUser } from '@/hooks/use-user'

export function FullStory() {
	const { user } = useUser()
	const fullStoryInitialized = !!window._fs_initialized

	const identifyUser = useCallback(() => {
		if (user?.username) {
			;(FullStoryBrowser as any).FullStory?.('setIdentity', {
				uid: user.username,
				properties: {
					displayName: user.name || '',
					email: user.email || '',
				},
			})
		}
	}, [user])

	useEffect(() => {
		if (!user || config.analyticsDisabled) return

		if (config.fullstory.orgId && !fullStoryInitialized) {
			// Initialize FullStory only if it hasn't been initialized
			FullStoryBrowser.init({ orgId: config.fullstory.orgId }, () => {
				identifyUser()
				window._fs_initialized = true // Flag to avoid reinitializing
			})
		} else if (fullStoryInitialized) {
			identifyUser()
		}
	}, [user, fullStoryInitialized, identifyUser])

	return null
}
